import {FC} from 'react';

import TaskLocationCode from '../../../components/Dictionaries/TaskLocations/task-location';

const TaskLocationPage: FC = () => {
  return (
    <div>
      <TaskLocationCode />
    </div>
  );
};

export default TaskLocationPage;
